import * as types from './mutation-types'

export const resourceGetPage = ({commit}, pageUuid) => {
  return Vue2.prototype.$api.active().get('pages/' + pageUuid)
    .then((response) => {
      commit(types.RESOURCE_SET_PAGE, response.data)

      return response
    })
}

export const resourceGetDisabledResources = ({commit}) => {
  return Vue2.prototype.$api.active().get('resources/disabled')
    .then((response) => {
      commit(types.RESOURCE_SET_DISABLED_RESOURCES, response.data)

      return response
    })
}

export const resourceGetActiveResources = ({commit}) => {
  return Vue2.prototype.$api.active().get('resources')
    .then((response) => {
      commit(types.RESOURCE_SET_RESOURCES, response.data)

      return response
    })
}

export const resourceGetCategories = ({commit}) => {
  return Vue2.prototype.$api.active().get('resources/categories')
    .then((response) => {
      commit(types.RESOURCE_SET_CATEGORIES, response.data)
    })
}